<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
    props: {
        metros: { type: Array, default: () => ([]) },
        regions: { type: Array, default: () => ([]) },
        communities: { type: Array, default: () => ([]) },
    },
    data: () => ({
        query: new URLSearchParams(window.location.search),
        activeListItem: '',
        activeItem: 'list',
        metroDropdown: false,
        cityDropdown: false,
        listHeightStyle: { },
        selectedMetros: [],
        selectedRegions: [],
        filteredCommunities: [],
    }),
    computed: {
        metrosList() {
            return this.metros
                .filter((metro) => this.selectedMetros.includes(metro.seo_name))
                .map((metro) => metro.name)
                .join(', ');
        },
        regionsList() {
            return this.regions
                .filter((region) => this.selectedRegions.includes(region.seo_name))
                .map((region) => region.name)
                .join(', ');
        }
    },
    watch: {
        selectedMetros(val) {
            if (val.length === 0) {
                // this.query.delete('metros');
            } else {
                // this.query.set('metros', val.join('+'));
            }
            // this.selectedRegions = [];
            // this.updateUrl();
            this.filterCommunities();
        },
        selectedRegions(val) {
            if (val.length === 0) {
                this.query.delete('regions');
            } else {
                this.query.set('regions', val.join('+'));
            }
            this.updateUrl();
            this.filterCommunities();
        }
    },
    created() {
        this.selectedRegions = this.query.get('regions') ? this.query.get('regions').split(/\+|\s|%2B/g) : [];
        let pathname = window.location.pathname;

        // If we're on a regional page, make sure we push the selected region to the selectedRegions array

        if (pathname.split('/').pop() !== 'find-your-home') {
            this.selectedMetros.push(pathname.split('/').pop());
        }

        this.filterCommunities();
    },
    mounted() {
        this.$eventsBus.$on('marker-over', this.handleMarkerOver);
        this.$eventsBus.$on('marker-out', this.handleMarkerOut);
        this.filterCommunities();
    },
    beforeDestroy() {
        this.$eventsBus.$off('marker-over', this.handleMarkerOver);
        this.$eventsBus.$off('marker-out', this.handleMarkerOut);
    },
    methods: {
        isActive: function (menuItem) {
            return this.activeItem === menuItem;
        },
        setActive: function (menuItem) {
            this.activeItem = menuItem;
            // need to run this when button gets clicked
            //google.maps.event.trigger(this.map, 'resize');
        },
        toggleMetroNav(menu) {
            this['cityDropdown'] = false;
            this[menu] = !this[menu];
        },
        toggleCityNav(menu) {
            this['metroDropdown'] = false;
            this[menu] = !this[menu];
        },
        scrollToCard() {
            const scrollElem = $('.where-we-build--list');
            const activeCard = $('.community-card--active');
            scrollElem.animate({
                scrollTop: activeCard.offset().top - 150 + scrollElem[0].scrollTop
            }, 600, 'swing');
        },
        handleMarkerOver(id) {
            this.activeListItem = id;
            this.$nextTick(this.scrollToCard);
        },
        handleMarkerOut(id) {
            this.activeListItem = '';
        },
        handleCardOver(id) {
            this.$eventsBus.$emit('community-over', id);
        },
        handleCardOut(id) {
            this.$eventsBus.$emit('community-out', id);
        },
        filterCommunities() {
            this.filteredCommunities = this.selectedMetros.length === 0 || this.selectedMetros[0] === 'where-we-build'
                ? this.communities.filter((community) => this.selectedRegions.length === 0 || this.selectedRegions.includes(community.region_seo_name))
                : this.communities.filter((community) => {
                    if (this.selectedRegions.length === 0) {
                        return this.selectedMetros.includes(community.metro_seo_name);
                    }
                    return this.selectedMetros.includes(community.metro_seo_name) && this.selectedRegions.includes(community.region_seo_name);
                });

            console.log(this.filteredCommunities.length + ' communities', this.selectedMetros, this.selectedRegions);
        },
        updateUrl() {

            const url = new URL(window.location);
           
            if(this.selectedRegions.length > 0){
               
                const regions = this.selectedRegions.join("+")

                console.log("regions ", regions)
                
                if(regions){
                    url.searchParams.set('regions', regions);
                } 

            }else {
                url.searchParams.delete('regions');
            }
            const urlFormatted = url.toString().replace(/%2B/g, '+');    
            window.history.pushState({}, "", urlFormatted);
            
            // let pathname = window.location.pathname;

            // If we're on a regional page, set it back to the where we build page
            /*
            if (pathname.split('/').pop() !== 'find-your-home') {
                pathname = pathname.split('/').slice(0, -1).join('/');
            }
            */
            // if (this.selectedMetros.length) {
            //     pathname = pathname.split('/').slice(0, -1).join('/') + '/' + this.selectedMetros;
            // };

           // history.replaceState({}, '', `${pathname}?${this.query.toString().replaceAll('%2B', '+')}`);
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/toggle-buttons-metro.vue